<template>
  <div
    class="p-the-a01-message-panel"
    :style="{
      '--site-light-color': lightColorCode
    }"
  >
    <div class="p-the-a01-message-panel__heading">
      <p class="p-the-a01-message-panel__title">最新のやりとり</p>
      <HelpTooltip :text="latestMessageTooltip" />
    </div>
    <div class="p-the-a01-message-panel__body">
      <template v-if="hasMessages">
        <div class="p-the-a01-message-panel__list">
          <A01MessageListPanel
            v-for="(message, key) in messages"
            :key="key"
            :message="message"
          />
        </div>
        <div class="p-the-a01-message-panel__more">
          <a :href="url" class="p-the-a01-message-panel__more-link">
            <span class="p-the-a01-message-panel__more-label">
              過去のやりとりをもっと見る
            </span>
            <IconBase
              class="p-the-a01-message-panel__more-icon"
              :width="24"
              :height="24"
              view-box="0 0 24 24"
              :icon-color="colorCode"
            >
              <IconArrowRight />
            </IconBase>
          </a>
        </div>
      </template>
      <p v-else class="p-the-a01-message-panel__empty">
        まだやりとりはありません。日頃の感謝を伝えてみませんか？
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import A01MessageListPanel from "@/general/components/pages/parts/Top/A01MessageListPanel.vue";
import HelpTooltip from "@/common/components/molecules/HelpTooltip.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight from "@/common/components/icons/IconArrowRight.vue";
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import commons from "@/common/store/modules/commons";
import CONST_DATA from "@/general/mixins/const/constData";

@Options({
  props: {
    messages: { type: Array, required: true }
  },
  components: {
    A01MessageListPanel,
    HelpTooltip,
    IconBase,
    IconArrowRight
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode,
      storeLightColorCode: () => commons.lightColorCode
    })
  }
})
export default class TheA01MessagePanel extends Vue {
  messages!: any[];
  storeColorCode!: string;
  storeLightColorCode!: string;

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get colorCode() {
    if (this.isGroupBudget) {
      return "#fc9014";
    }
    return this.storeColorCode;
  }

  get lightColorCode() {
    if (this.isGroupBudget) {
      return "#FFF5E8";
    }
    return this.storeLightColorCode;
  }

  get hasMessages() {
    return Array.isArray(this.messages) && this.messages.length > 0;
  }

  get url() {
    return CONST_DATA.SITE_MAP.THANKS_POINT;
  }

  get latestMessageTooltip() {
    return CONST_DATA.TOOLTIP_TEXT.LATEST_MESSAGE;
  }
}
</script>

<style lang="scss" scoped>
.p-the-a01-message-panel {
  display: flex;
  flex-direction: column;
  gap: rem(16);
  width: 100%;
  min-width: 0;

  @include large-sp {
    gap: rem(8);
  }

  &__heading {
    display: flex;
    gap: rem(4);
    align-items: center;
  }

  &__title {
    color: #1f2021;
    font-family: $font--noto-sans-only;
    font-size: rem(20);
    font-weight: 700;
    line-height: 1.25;
    white-space: nowrap;
    font-feature-settings: "pwid" 1, "palt" 1;

    @include sp {
      font-size: rem(16);
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: rem(16);
    width: 100%;
    min-width: 0;
  }

  &__empty {
    margin: 0;
    color: #1f2021;
    font-family: $font--noto-sans-only;
    font-size: rem(16);
    font-weight: 400;
    line-height: 1.5;
    font-feature-settings: "pwid" 1, "palt" 1;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: rem(16);
    width: 100%;
    height: rem(192);
    padding: rem(24);
    overflow-x: hidden;
    overflow-y: auto;
    background-color: var(--site-light-color);

    @include large-sp {
      height: rem(160);
    }
  }

  &__more {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  &__more-link {
    display: flex;
    flex-shrink: 0;
    gap: rem(4);
    align-items: center;
    justify-content: center;
    min-width: rem(240);
    height: rem(36);
    padding: 0 rem(8);
    background-color: $common-white;
    border: px(2) solid #1f2021;
    border-radius: rem(4);

    @include sp {
      min-width: rem(202);
      height: rem(34);
    }
  }

  &__more-icon {
    flex-shrink: 0;
  }

  &__more-label {
    color: #1f2021;
    font-family: $font--noto-sans-only;
    font-size: rem(16);
    font-weight: 700;
    line-height: 1.25;
    white-space: nowrap;
    font-feature-settings: "pwid" 1, "palt" 1;

    @include sp {
      font-size: rem(14);
    }
  }
}
</style>
